// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ql-0";
export var leftAlign = "_ql-4";
export var listItem = "_ql-2";
export var listItemWrapper = "_ql-1";
export var operationText = "_ql-3";